import React from 'react'
export const locale = {
    curren_user_name:'אתר שוק',
    my_products:'מוצרים והצעות',
    manage_products_offers:'ניהול מוצרים והצעות',
    add_new_product:'הוספת מוצרים',
    orders:'הזמנות',
    manage_orders:'ניהול הזמנות',
    what_to_sell : "מה תרצה למכור?",
    search_placeholder: "חיפוש לפי שם מוצר או מספר סידורי",
    tooltip_search_hint: "התחל בהוספת המוצרים שלך על ידי חיפוש לפי השם או מספר הדגם שלהם",
    search:'חיפוש',
    categories:'קטגוריות',
    product_bulk_upload_heading: 'האם יש לך רשימת מוצרים מוכנה?',
    product_bulk_upload_desc:'אם רשימת המוצרים שלך מוכנה ועומדת בתקני הרישום, לחץ על כפתור העלאה.',
    product_bulk_upload_desc_2:'אם רשימת המוצרים שלך מוכנה, אנא שלח אותה אלינו בדוא"ל:',
    product_bulk_upload_button:'העלאת רשימת מוצרים',
    load_more_categories:'טעינת קטגוריות נוספות...',
    sell_this_product:'מכור מוצר זה',
    required:':field נדרש',
    quantity:'כמות',
    price:"מחיר",
    sku:"מק\"ט מוצר",
    seller_notes:"הערות מוכר",
    handling_time:"זמן הכנה",
    product_condition:"מצב המוצר",
    pcondition:"מצב המוצר",
    specify_your_own: 'אחר?',
    choose: 'בחר...',
    // product_title_ar: 'כותרת מוצר (ערבית)',
    product_title_ar: 'כותרת מוצר',
    // product_description_ar: 'תיאור מוצר (ערבית)',
    product_description_ar: 'תיאור מוצר',
    product_breadcrumb_prefix: 'קטגוריית מוצר:',
    // product_tooltip_title: 'כותרת מוצר (ערבית)',
    product_tooltip_title: 'כותרת מוצר',
    // product_tooltip_description_ar: '<div>תיאור מוצר בערבית</div><div class="tooltip__content">מהם המפרטים והפרטים של המוצר שברצונך למכור?</div>',
    product_tooltip_description_ar: '<div>תיאור מוצר</div><div class="tooltip__content">מהם המפרטים והפרטים של המוצר שברצונך למכור?</div>',
    btn_create_product: 'הוסף מוצר',
    create_product:'הוספת מוצר חדש',
    btn_cancel: 'ביטול',
    btn_next: 'הבא',
    btn_prev: 'הקודם',
    sell_the_product: 'מכור מוצר: ',
    sell_product_tooltip_quantity: 'כמות',
    sell_product_tooltip_price: 'מחיר',
    sell_product_tooltip_old_price: '<div>מחיר ישן</div><div class="tooltip__content">השאר ריק אם למוצר אין מחיר ישן</div>',
    sell_product_tooltip_sku: 'מק"ט מוצר',
    sell_product_tooltip_notes: '<div>הערות מוכר</div><div class="tooltip__content">הוסף הערות אישיות על מוצר זה, לא פרטי המוצר</div>',
    sell_product_tooltip_handling_time: 'זמן נדרש להכנת המוצר',
    sell_product_product_condition: 'מצב שימוש במוצר',
    sell_product_tooltip_free_shipping: 'משלוח חינם?',
    btn_add_product_to_sell: 'הוסף מוצר',
    shipping_delivery_option: 'שיטת מסירת ההזמנה',
    shipping_to_westbank: 'משלוח לגדה המערבית',
    shipping_to_jerusalem: 'משלוח לירושלים',
    shipping_to_48_area: 'משלוח לאזורי 48',
    shipping_to_gaza: 'משלוח לעזה',
    free_shipping: 'כמוכר, אכסה את עלות המשלוח לגדה המערבית (תשלם את דמי המשלוח)',
    free_shipping_jerusalem: 'כמוכר, אכסה את עלות המשלוח לירושלים (תשלם את דמי המשלוח)',
    free_shipping_gaza: 'כמוכר, אכסה את עלות המשלוח לעזה (תשלם את דמי המשלוח)',
    free_shipping_48: 'כמוכר, אכסה את עלות המשלוח לאזורי 48 (תשלם את דמי המשלוח)',
    apply_price_to_all:'החל מחיר על הכל',
    apply_sku_to_all:'החל מק"ט על הכל',
    copyrights:'כל הזכויות שמורות - חנות שוק ©',
    numeric_only:'שדה זה חייב להיות מספרי',
    product_name: 'שם מוצר',
    status: 'סטטוס',
    old_price: 'מחיר ישן',
    updated_at: 'עודכן לאחרונה',
    next:'הבא',
    previous:'הקודם',
    pickup_from:'כתובת החנות שבה נמצא המוצר',
    edit_product_breadcrumb_prefix:'עריכת מוצר:',
    product_arabic_title_is_required:'שם המוצר נדרש!',
    product_arabic_description_is_required:'תיאור המוצר נדרש!',
    error_page_not_found: 'מצטערים, דף זה לא קיים או שאין לך הרשאה לצפות בו!',
    btn_update: 'עדכן',
    no_more_products_or_offers: 'מצטערים, אין עוד מוצרים או הצעות.',
    product_details: 'מידע על המוצר',
    show_product_details: 'הצג את כל הפרטים',
    what_type_of_product: 'איזה סוג מוצר?',
    current_page: 'עמוד:',
    order_number: 'הזמנה #',
    fees: 'עמלות',
    order_sub_total: 'סכום ביניים',
    order_total: 'סה"כ',
    buyer_name: 'שם קונה',
    order_date: 'תאריך הזמנה',
    no_orders_found: 'לא נמצאו הזמנות ברשימה זו!',
    no_products_found: 'לא נמצאו מוצרים בקטגוריה זו!',
    no_products_found_by_search: 'לא נמצאו תוצאות חיפוש!',
    all_categories: 'כל הקטגוריות',
    sell_product_added_successfully: 'המוצר נוסף בהצלחה לרשימת המכירה שלך!',
    your_product_updated_successfully: 'המוצר עודכן בהצלחה!',
    changing_order_status: 'משנה סטטוס הזמנה...',
    order_changed_successfully_to_next_step: 'סטטוס ההזמנה הועבר בהצלחה לשלב הבא',
    an_error_occurred_while_changing_order_status: 'אירעה שגיאה בעת שינוי סטטוס ההזמנה!',
    this_order_in_queue: 'הזמנה זו מטופלת כרגע...',
    did_not_you_found_your_product: 'לא מצאת את המוצר שלך בתוצאות?',
    add_new_product_now: 'הוסף את המוצר שלך עכשיו',
    add_new_product_now_if_not_exists: 'הוסף את המוצר שלך לקטלוג עכשיו',
    please_fill_the_required_fields: 'אנא מלא את השדות הנדרשים!',
    an_error_occurred_while_creating_your_product: 'אירעה שגיאה בלתי צפויה בעת הוספת המוצר שלך!',
    an_error_occurred_while_submitting_form: 'אירעה שגיאה בלתי צפויה בעת שליחת הנתונים!',
    an_error_occurred_while_check_login: 'אירעה שגיאה בעת בדיקת סטטוס התחברות',
    remove: 'מחק',
    product_images: 'תמונות מוצר',
    are_you_sure_to_delete_this_item: 'האם אתה בטוח שברצונך למחוק פריט זה?',
    cannot_upload_this_file: 'לא ניתן להעלות קובץ זה!',
    you_have_canceled_the_file_upload: 'ביטלת את העלאת הקובץ!',
    update_sell_product: 'ערוך',
    update_product_props: 'מפרטים',
    product_template_updated_successfully: 'תכונות המוצר עודכנו בהצלחה. הן יוחלו לאחר סקירת מנהל.',
    you_did_not_change_values_to_update_product: 'לא שינית את המוצר כדי לעדכן אותו!',
    you_did_not_change_values_to_create_product: 'עדיין לא הזנת נתוני מוצר!',
    login: 'התחברות',
    login_to_your_account: 'התחבר לחשבון שלך',
    email: 'דוא"ל',
    password: 'סיסמה',
    remember_me: 'זכור אותי',
    logout: 'התנתקות',
    logout_success:'התנתקת בהצלחה.',
    please_login_to_access: 'אין לך הרשאה מספקת לגשת לדף זה. אנא התחבר כדי להמשיך.',
    failed_validation_notificant_title: (errorsCount)=>{
        switch (errorsCount){
            case 1:
                return 'נמצא שדה נדרש אחד!';
            case 2:
                return 'נמצאו 2 שדות נדרשים!';
            default:
                return 'נמצאו '+errorsCount+' שדות נדרשים!';
        }
    },

    get:function(name, placeholders = {}) {
        let occurrence = this[name] ||  name;
        Object.keys(placeholders).forEach(function (key) {
            occurrence = occurrence.replace(new RegExp(':' + key), placeholders[key]);
        });
        return occurrence;
    },

    login_failed:'דוא"ל או סיסמה שגויים',
    email_is_required:'דוא"ל נדרש.',
    password_is_required:'סיסמה נדרשת.',
    facebook_login_failed:'אירעה שגיאה בעת התחברות דרך פייסבוק. אנא וודא שאתה מחובר לפייסבוק.',
    email_is_not_valid:'כתובת דוא"ל לא תקינה.',
    product_images_required:'המוצר דורש לפחות תמונה אחת.',
    barcode:'ברקוד',
    cannot_edit_pending_product :'<div> <strong>מוצר ממתין לאישור:</strong> תוכל לערוך את המוצר לאחר האישור או לאחר השינויים המבוקשים.</div>',

    mobile_confirm_title:'אימות מספר טלפון',
    mobile_confirm_required_to_sell:'כדי למכור מוצרים באתר שוק, עליך לאמת את החשבון שלך באמצעות מספר הטלפון שלך.',
    activation_code : 'קוד אימות',
    activate:'אמת',
    send_activation : 'שלח קוד אימות',

    mobile_update_title:'הוסף מספר טלפון',
    mobile_update_required:'מספר טלפון נדרש להוספת מוצרים.',
    mobile_number:'מספר טלפון',
    save:'שמור',

    mobile_is_required:"מספר טלפון נדרש",
    mobile_is_invalid:"מספר טלפון לא תקין",
    mobile_require_activation:"מספר הטלפון דורש אימות",
    yes:"כן",
    no:"לא",
    add_option:"הוסף:",
    minimum_characters_to_search: "אורך חיפוש מינימלי הוא 3 תווים!",
    at_least_one_variant_required:'לפחות מוצר אחד חייב להיות מופעל',
    apply_to_all:'החל על הכל',
    apply_images:'העתק תמונות ל...',
    apply_all:'החל על הכל',
    shipping:'משלוח',
    relogin_to_your_account:'התחברות',
    relogin_to_your_account_hint:'לבטחונך, התנתקת אוטומטית. אנא התחבר שוב.',
    relogin_success:'התחברת שוב. כעת תוכל לשמור את השינויים שלך.',
    buyer_notes:'הערות קונה',
    you_have_a_note_from_buyer:'יש לך הערה מהקונה',
    your_account_requires_email_activation:'החשבון דורש אימות דוא"ל',
    resend:'שלח שוב קישור אימות',
    shippping_policy: 'מדיניות משלוח',
    email_or_mobile : 'דוא"ל או מספר טלפון',
    convert_product_to_package_by_price:"מחיר המוצר נמוך מ-100 ש\"ח.",
    convert_product_to_package_by_price_desc:"המחיר ליחידה נמוך מהמחיר המועדף בשוק. המוצר חייב להכיל יותר מיחידה אחת כדי להגיע למחיר המועדף.",
    number_of_pieces:"מספר יחידות",
    pieces_price_is_little:"מחיר היחידה חייב להיות יותר מ-100 ש\"ח.",
    ok:"אישור",
    cancel:"ביטול",
    price_per_piece:"מחיר ליחידה",
    system_currency:"ש\"ח",
    no_keep_price_as_is:"כן, שמור מחיר כמו שהוא",
    product_bulk_uploading_now:"מעלה מוצרים...",
    business_requirements_update:"נדרש מידע עסקי מסוים",
    update:"עדכן",
    business_requirements_update_desc:"כדי להתחיל למכור באתר, עליך למלא את השדות הבאים.",
    business_contact_phone : "מספר טלפון עסקי",
    hide:'הסתר',
    select_upload_category:"בחר קטגוריית מוצר",
    mapping_upload_fields:"מפה עמודות",
    bulk_upload_invalid_extension:"סיומת הקובץ שהועלה לא מותרת.",
    shipper:"משגר",
    shipping_by_seller:"משלוח על ידי מוכר (הזמנות רכישה לא יישלחו לחברת משלוחים)",
    shipping_method:"שיטת משלוח",
    order_shipping_by_seller:"נשלח על ידי מוכר",
    order_shipping_by_shooq:"נשלח על ידי שוק",
    order_details:"פרטים",
    address:"כתובת",
    mobile:"טלפון",
    total_products:"סה\"כ מוצרים",
    total_ready_orders:":completed מתוך :total_orders",
    show_orders_count:":currentTotal מתוך :total_orders מוצרים",
    payment_method:"שיטת תשלום",
    shippping_policy_for_all:"מדיניות משלוח לכולם",
    email_confirm_title:'דוא"ל דורש אימות',
    email_confirm_required_to_sell:'אנא אמת את החשבון שלך דרך דוא"ל :email כדי להשתמש בשירותי שוק.',
    done:'הושלם',
    resend_email_activation:'שלח שוב דוא"ל אימות',
    string_max_length_exceeded:'אורך הטקסט לא יכול לעלות על :size',
    views:"צפיות",

    update_pieces:"עדכן מחיר ויחידות",

    no_lists_uploaded:"עדיין לא הועלו רשימות מוצרים.",
    file_name:"שם קובץ",
    upload_date:"תאריך העלאה",
    file_type:"סוג קובץ",
    completed_products:"מוצרים שהושלמו",

    pending_products:"מוצרים ממתינים",

    product_title:"שם מוצר",
    product_description:"תיאור מוצר",
    product_image:"תמונת מוצר",
    product_title_required:"שדה שם מוצר נדרש",
    product_price_required:"שדה מחיר מוצר נדרש",
    product_quantity_required:"שדה כמות מוצר נדרש",

    required_field:"שדה זה נדרש.",
    suggested_products:"מוצרים מוצעים",

    products_list:"רשימת מוצרים",
    complete:"הושלם",
    select:"בחר",
    deselect:"בטל בחירה",
    sell:"מכור",
    sold:"נמכר",
    selling:"מוכר",
    add_product:"הוסף מוצר",

    download_bulk_samples:"הורד תבניות דוגמה",
    payment_method_fees:"עמלות שיטת תשלום",
    shipping_fees:"עמלות משלוח",
    sub_total:"סכום ביניים",
    total:"סה\"כ",

    financial: 'פיננסי',
    financial_account_summary: 'סיכום חשבון פיננסי',
    financial_month_summary: 'סיכום מכירות חודשי',
    financial_transactions: 'עסקאות פיננסיות',
    manage_bank: 'חשבון בנק',

    select_month: 'בחר חודש',
    submit: 'שלח',
    details: 'פרטים',
    financial_total_balance: 'יתרה כוללת',
    financial_month_balance: 'יתרה עבור: <span dir="rtl">:month</span>',
    sold_products: 'מוצרים שנמכרו',
    withdraw_request: 'בקש משיכה',
    you_withdrawal_requests_is_processing: 'מעבד',

    my_bank_details: 'פרטי הבנק שלי',
    beneficiary_name: 'שם בעל החשבון',
    bank_name: 'שם הבנק',
    bank_account_number: 'מספר חשבון בנק',
    bank_branch: 'סניף בנק',
    bank_iban: 'IBAN',
    save_details: 'שמור פרטים',
    iban_is_invalid: 'IBAN לא תקין!',
    please_select_valid_bank: 'אנא בחר בנק מהרשימה!',
    please_fill_all_required_fields: 'אנא מלא את כל השדות הנדרשים',

    an_error_occurred_while_initializing_data: 'אירעה שגיאה בעת קבלת המידע שלך!',
    your_bank_details_saved_successfully: 'פרטי הבנק שלך נשמרו בהצלחה',
    an_error_occurred_while_saving_your_bank_details: 'אירעה שגיאה בעת שמירת פרטי הבנק שלך!',

    what_is_iban: 'מה זה IBAN?',
    what_is_iban_description: '' +
        '<p>ה-IBAN מורכב מאותיות ומספרים ויכול להיות עד 34 תווים: שתי האותיות הראשונות הן קוד המדינה, ואחריהן שתי ספרות ביקורת, ואחריהן מספר חשבון הבנק המקומי.</p>' +
        '<p>IBAN לא יכול להכיל רווחים כאשר נשלח אלקטרונית. כאשר מודפס, IBAN מחולק לקבוצות של ארבעה תווים מופרדות ברווחים. הקבוצה האחרונה יכולה להיות קצרה יותר, למשל:</p>' +
        '<p>מדינה ILXX XXX XXXX XXXX XXXX XXXX XXXX X</p>' +
        '<p>IBAN יכול להכיל רק ספרות 0–9 ואותיות גדולות A–Z. זה חל גם על שמות מדינות, למשל "ערב הסעודית".</p>' +
        '',

    business_name: 'שם עסק',
    payment_way: 'סוג תשלום',
    credit: 'אשראי',
    debit: 'חיוב',
    notes: 'הערות',

    month: 'חודש',
    total_sales: 'מכירות כוללות',
    total_sales_shipped_by_seller: 'מכירות שנאספו על ידי מוכר',
    setup_fees: 'עמלות הגדרה',
    lazmak_commission: 'עמלת מכירות',
    net_sales: 'מכירות נטו',
    balance: 'יתרה',
    no_transactions_found: 'עדיין אין עסקאות פיננסיות.',
    is_replaced_item: 'הוחלף',
    please_fill_your_bank_details_to_access_to_financial_area: 'אנא מלא את פרטי הבנק שלך כדי לגשת למידע פיננסי',
    click_here_to_go_to_manage_banks: 'לחץ כאן כדי למלא את פרטי הבנק שלך.',
    free_shipping_notification_message: 'על ידי בחירה באחת מהאפשרויות הבאות, אתה מסכים לכסות את עלות משלוח המוצר במקום הקונה.',

    invoices: 'חשבוניות',
    create_invoice: 'צור חשבונית',
    receiver_name: 'שם מקבל',
    description: 'תיאור',
    new_invoice_row: 'הוסף שורה חדשה',
    invoice_row_is_required: 'פריטי חשבונית נדרשים',
    currency: 'מטבע',
    currency_ils: 'ש"ח',
    currency_usd: 'דולר',
    is_not_valid:':field לא תקין',
    view_invoice:'הצג חשבונית',
    invoice_created_successfully:'החשבונית נוצרה בהצלחה.',
    no_invoices_found:'לא נמצאו חשבוניות מהחשבון שלך',
    your_store_account_has_not_been_approved_yet:'החשבון של חנות (:store_name) נמצא כעת בבדיקה על ידי הנהלת האתר ועדיין לא אושר.',
};

